import { createElement } from '../modules/globalFunctions'
import { fetchHTMLfromURL } from '../modules/dataFetchers'

// blog on homepage - changes title and buttons text, moves the block, adds a button for all articles
const blogOnHomepage = () => {
	const blogBlock = document.querySelector('.homepage-blog-wrapper')
	if (!blogBlock) return
	sessionStorage.setItem('_.homepage-blog-wrapper', blogBlock.innerHTML)

	// const benefitBanner = document.querySelector('.container > .welcome-wrapper')
	// if (benefitBanner) benefitBanner.after(blogBlock)
	const blogBlockTitle = blogBlock.querySelector('.homepage-group-title')
	const blogBlockButton = blogBlock.querySelector('.btn')
	if (blogBlockTitle) blogBlockTitle.textContent = window.language === 'cs' ? 'Blog o nás' : 'Blog' //jazyk
	const blogBlockButtonWrapper = createElement('div', ['button-wrapper'])
	const blogBlockButtonAll = createElement('a', ['btn', 'btn-primary'], window.language === 'cs' ? 'Zobrazit blog' : 'Zobraziť blog') //jazyk
	blogBlockButtonAll.href = '/blog'
	blogBlockButtonWrapper.appendChild(blogBlockButtonAll)
	blogBlock.appendChild(blogBlockButtonWrapper)

	const newsItems = blogBlock.querySelectorAll('.news-item')
	if (newsItems.length === 0) return
	const newsItemsWrapper = createElement('div', ['news-items-wrapper'])
	for (const newsItem of newsItems) {
		newsItemsWrapper.appendChild(newsItem)
		const newsItemButton = newsItem.querySelector('.read-article')
		if (newsItemButton) newsItemButton.textContent = window.language === 'cs' ? 'Přečíst článek' : 'Prečítajte si článok' //jazyk
	}
	blogBlockButtonWrapper.before(newsItemsWrapper)
	$(newsItemsWrapper).slick({
		slidesToShow: 3,
		infinite: false,
		dots: false,
		arrows: false,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 850,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 560,
				settings: {
					slidesToShow: 1.25,
					arrows: false,
					dots: true,
				},
			},
		],
	})
}

const addLinkToArticles = () => {
	const newsItems = document.querySelectorAll('.news-item')
	for (const newsItem of newsItems) {
		const newsItemLink = newsItem.querySelector('a.title')
		if (newsItemLink) {
			let addedLink
			// jazyk
			addedLink = createElement('a', ['read-article'], window.language === 'cs' ? 'Přečíst článek' : 'Prečítajte si článok')
			addedLink.href = newsItemLink.href
			const text = newsItem.querySelector('.text')
			if (text) text.appendChild(addedLink)
		}
	}
}

const blogInCategory = () => {
	const contentWrapperIn = document.querySelector('.content-wrapper-in')
	if (!contentWrapperIn) return
	let blogBlock
	if (sessionStorage.getItem('_.homepage-blog-wrapper')) {
		blogBlock = createElement('div', ['homepage-blog-wrapper'])
		blogBlock.innerHTML = sessionStorage.getItem('_.homepage-blog-wrapper')
	} else {
		fetchHTMLfromURL('/', '.homepage-blog-wrapper').then((fetchedBlogBlock) => {
			blogBlock = fetchedBlogBlock
		})
	}
	contentWrapperIn.append(blogBlock)
	blogOnHomepage()
}

const moveBlogTimeToImg = () => {
	const newsItems = document.querySelectorAll('.news-item')
	for (const newsItem of newsItems) {
		const time = newsItem.querySelector('time')
		const img = newsItem.querySelector('.image')
		if (time && img) img.appendChild(time)
	}
}

export { blogOnHomepage, addLinkToArticles, blogInCategory, moveBlogTimeToImg }
